import { travelerApi } from "./api";

export const travelerReducers = {
  [travelerApi.reducerPath]: travelerApi.reducer,
};

export const travelerMiddlewares = [travelerApi.middleware];
